import store from "../store";

let refreshPromise = null;

function getPersistedUser() {
  try {
    const rawUser = localStorage.getItem("USER_PROFILE");
    const user = rawUser ? JSON.parse(rawUser) : null;
    return user && typeof user === "object" ? user : {};
  } catch (error) {
    return {};
  }
}

export function getSessionToken() {
  return (
    store.state.user.token ||
    (typeof localStorage !== "undefined" && localStorage.getItem("USER_TOKEN")) ||
    ""
  );
}

function getSessionEmail() {
  return store.state.user.user?.email || getPersistedUser().email || "";
}

/**
 * Comparte la única renovación de sesión de toda la plataforma.
 *
 * El backend rota el refresh token al usarlo. Por eso los clientes Axios no
 * pueden mantener una promesa de refresh cada uno: dos peticiones 401
 * simultáneas convertirían la segunda renovación en un token revocado.
 */
export function refreshSession() {
  if (!refreshPromise) {
    const email = getSessionEmail();

    if (!email) {
      return Promise.reject(
        new Error("No hay una sesión disponible para renovar"),
      );
    }

    refreshPromise = Promise.resolve(
      store.dispatch("user/refreshToken", { email }),
    )
      .then((token) => {
        if (typeof token !== "string" || !token) {
          throw new Error("No se pudo renovar la sesión");
        }
        return token;
      })
      .finally(() => {
        refreshPromise = null;
      });
  }

  return refreshPromise;
}
